import { ReactComponent as Empty } from "../../src/media/unexpected_friends.svg";
import TopNavbarBack from "./TopNavbarBack";
import GoToTop from "./GoToTop";

const EmptyPage = ({ caption }) => {
  return (
    <>
      <TopNavbarBack
        title=""
        rbuttonIcon={["icon-iconchevron-right"]}
        rbackground={["rectangle1"]}
        lbuttonIcon={["dNone"]}
        lbuttonHref={["null"]}
        lbackground={["null"]}
        className="fixedPosition"
      />
      <div className="paddingTop20">
        <Empty className="radius2" alt="empty"></Empty>
        <h5 className="subject-1 yekan">{caption}</h5>
      </div>
      <GoToTop />
    </>
  );
};
export default EmptyPage;
